import { UrlSegment } from "@angular/router";

export class CategoryMatcher {

  /*
    Match the first UrlSegment with the passed category and pass the following UrlSegments as posParams
  */

  private static categorySlugIndex = 0

  public static match(url : UrlSegment[]) {

    // do not try to route old images
    if (url.length) {
      const lastpath = url[url.length - 1]
      if (lastpath) {
        if (lastpath.path.match('.jpg|.png|.webp')) {
          return null
        }
      }
    }

    if (url[this.categorySlugIndex] && url[this.categorySlugIndex].path.match(/^([\w]|-|_|[\d])+.html$/gm) == null) {

      let categories : String[] = []

      for (let index = this.categorySlugIndex; index < url.length; index++) {
        categories.push(url[index].toString())
      }

      return {
        consumed: url,
        posParams: {
          mainCategory: url[this.categorySlugIndex],
          categories: new UrlSegment(JSON.stringify(categories), {}),
          slug: new UrlSegment(categories.join("/"), {}),
        }
      }
    }

    return null
  }

}
